import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/devtools/ui")({
  component: lazyRouteComponent(() => import("./+UILibrary")),
  head: () => ({ meta: seo({ title: "UI Library" }) }),
});
